export function isEmpty(array) {
  return !Array.isArray(array) || !array.length
}

export function sortArrayByPropName(array, propName) {
  return array.sort((a, b) => {
    if (a[propName] < b[propName]) return -1
    if (a[propName] > b[propName]) return 1
    return 0
  })
}

export function removeFromArray(array, value) {
  const index = array.indexOf(value)
  if (index >= 0) array.splice(index, 1)

  return array
}
